import { DeleteForever, Edit } from '@mui/icons-material'
import React from 'react'
import CustomIconButton from "../../CustomTooltipIconButton"

const buildActions = (value) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
      <CustomIconButton
        onClick={value.edit}
        tooltipTitle="Editar registro"
        icon={<Edit />}
      />

      <CustomIconButton
        onClick={value.remove}
        tooltipTitle="Remover registro"
        icon={<DeleteForever />}
      />
    </div>
  )
}

export const columns = [
  {
    name: 'key',
    label: 'Palavra-chave',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'actions',
    label: 'Ações',
    options: {
      filter: false,
      sort: false,
      download: false,
      customBodyRender: (value) => buildActions(value),
      setCellProps: () => ({
        style: {
          width: '100px',
        },
      }),
    },
  },
]
